import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";

// components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
} from "reactstrap";
import Header from "../../components/Headers/Header.jsx";

import { showMessage } from "../../services/message.js";
import { api_GET } from "../../services/api_service.js";

export default function DownloadAPP({ history }) {

    const [url, set_url] = useState(null);
    const loadURLAPP = () => {
        api_GET("setupsistema/GetURLAPPColetor").then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_url(result.data);
            }
        });
    }

    useEffect(() => {
        loadURLAPP();
    }, []);

    return (
        <>
            <Header />
            <Container className="mt--9" fluid>

                <Row>
                    <Container className="mt-1" fluid>
                        <Card className="shadow">
                            <CardHeader className="border-0">
                                <Row>
                                    <Col md="12">
                                        <strong> Download Aplicativo</strong>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md="12" className="text-center">
                                        {url && <QRCode value={url} />}
                                    </Col>
                                    <Col md="12" className="text-center mt-4">
                                        {url && <h5>Scaneie o QR Code acima ou <a href={url} target="_blank">clique aqui</a> para baixar o aplicativo</h5>}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Container>
                </Row>
            </Container>

        </>
    );
}
